















import Vue from 'vue';
import PoweredBy from './poweredBy.vue';

export default Vue.extend({
    props: ['langs','addBackBtn'],
    components: {
        PoweredBy,
    },
    computed: {
        sortedLangs() {
            return this.langs?.sort() || [];
        },
        enableWhiteLabel() {
            return this.$vstore.settings.state.channelSettings.enableWhiteLabel;
        }
    },
    data() {
        return {
            WhiteLabelUrl: 'https://res.cloudinary.com/tactful/image/upload/v1622640081/tactful_logo_1_mtlklq.svg',
        };
    },
    methods: {
        selectLang(lang: string) {
            this.$emit('selectLang',lang);
        },
        backToChat(){
            this.$emit('backToChat');
        },
    }
});
